module.exports = __webpack_public_path__ + "img/logos-truora-main@3x.ea534fc9.png";